import React from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../config/site';
import BrandLogo from './BrandLogo';

export default function Footer() {
  return (
    <footer className="store-footer">
      <div className="store-footer-grid">
        <div className="store-footer-brand">
          <BrandLogo variant="footer" />
          <p>{SITE.tagline}</p>
          <div className="store-social">
            <a href={SITE.social.instagram} target="_blank" rel="noreferrer">
              Instagram
            </a>
            <a href={SITE.social.facebook} target="_blank" rel="noreferrer">
              Facebook
            </a>
            <a href={`https://wa.me/${SITE.whatsapp}`} target="_blank" rel="noreferrer">
              WhatsApp
            </a>
          </div>
        </div>

        <div>
          <h4>Links</h4>
          <Link to="/">Inicio</Link>
          <Link to="/catalogo">Catálogo</Link>
          <Link to="/catalogo-unas">Uñas</Link>
          <Link to="/contacto">Contacto</Link>
        </div>

        <div>
          <h4>Contacto</h4>
          <p>{SITE.addressShort}</p>
          {SITE.hoursLines.map((line) => (
            <p key={line}>{line}</p>
          ))}
          {SITE.phones.map((p) => (
            <a key={p} href={`tel:+57${p.replace(/\s/g, '')}`}>
              +57 {p}
            </a>
          ))}
          <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a>
        </div>
      </div>

      <div className="store-footer-bottom">
        <span>© Todos los derechos reservados {SITE.name.replace('¡', '').trim()} {new Date().getFullYear()}</span>
        <span className="store-invima">Productos con registro INVIMA</span>
      </div>
    </footer>
  );
}
